export const type = 'alert.messageInfo';
